//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Class PageRoute. */
export const PageRoute = {
    /**
     * The CheckinManager route guid
     * The /checkinmanager route guid
     */
    CheckInManager: "A2B6EA1C-9E46-42C8-ABE4-0FD32D562B48",
    /** The /checkinmanager/attendance-detail route guid */
    CheckInManagerAttendanceDetail: "FB89DA07-CB29-4786-85FF-8814F43511B2",
    /** The edit person route '/Person/{PersonId}/Edit' */
    EditPersonRoute: "FCC0CCFF-8E18-48D8-A5EB-3D0F81D68280",
    /** The external site Workflow Entry route 'WorkflowEntry/{WorkflowTypeGuid}'. */
    ExternalWorkflowEntry: "ABDBED7B-93F5-4341-8B38-5E96F3009A1E",
    /** The external site Workflow Entry route 'WorkflowEntry/{WorkflowTypeGuid}/{WorkflowGuid}'. */
    ExternalWorkflowEntryWithWorkflow: "D8031879-92FD-4782-9AEB-715D6D290434",
    /** The financial account search route 'Account/Search/name/?SearchTerm=' */
    FinancialAccountSearch: "76A96F05-5B89-407B-A72E-5CB4FA64A11A",
    /** Gets the Campus Detail &gt; Group Member Detail page route guid */
    GroupMemberDetailCampusDetail: "9660B9FB-C90F-4AFE-9D58-C0EC271C1377",
    /** The oidc authorize route. */
    OidcAuthorize: "E35CD82E-C162-444E-AC5F-E42F20DA79F3",
    /** The oidc logout route. */
    OidcLogout: "5137F15D-61EA-4935-A9E1-16534959AEFA",
    /** The phone number lookup */
    PhoneNumberLookup: "1FB5A224-9E26-47E6-9A20-5B5A59B5C7CF",
    /** Gets the Registration Template Placement page route guid */
    RegistrationTemplatePlacement: "1F51EC08-7287-4A4C-BF36-2CCB57A02EE4",
    /** Gets the RSVP Response page route guid. */
    Rsvp: "6BE4EE11-694A-4D3E-B3A7-F6B2946012B9",
    /** The Step Program Flow route 'steps/program/{ProgramId}/flow' */
    StepFlow: "4F75872B-EBE0-43FA-A8F3-ED716B45A1A6",
    /** The system communication preview route 'Admin/Communications/System/Preview' */
    SystemCommunicationPreview: "AAC42941-8B2C-4F20-923D-E74146D2E103",
    /** Gets the Text To Give Setup page route guid */
    TextToGiveSetup: "58592279-6CD7-47FD-BD0C-E35784FF69FF",
};
